import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrossBlack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#212529",
		fillRule: "evenodd",
		d: "M19.167 4.844c-.443-.444-1.16-.444-1.604 0L12 10.396 6.437 4.833c-.444-.444-1.16-.444-1.604 0-.444.443-.444 1.16 0 1.604L10.396 12l-5.563 5.563c-.444.444-.444 1.16 0 1.604.443.444 1.16.444 1.604 0L12 13.604l5.563 5.563c.444.444 1.16.444 1.604 0 .444-.443.444-1.16 0-1.604L13.604 12l5.563-5.563c.433-.432.433-1.16 0-1.593z"
	})
});
export default SvgCrossBlack;
